var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 189,
    viewBox: "0 0 222 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_704_58",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 222,
    height: 189
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 189,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_704_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.214786 100.214L31.9251 131.702L31.9471 170.42C31.9414 172.508 32.3484 174.576 33.1447 176.506C33.9411 178.436 35.111 180.189 36.5873 181.665C37.5601 182.635 38.6512 183.478 39.8349 184.175C42.2149 185.596 44.9272 186.364 47.6987 186.403C50.4701 186.442 53.2028 185.749 55.6215 184.395L221.605 95.8621L0.214786 100.214Z",
    fill: "#2356c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69206 91.7982L221.937 96.283L55.6057 4.92351C53.1775 3.57059 50.4378 2.87606 47.6583 2.90883C44.8788 2.94159 42.1562 3.70052 39.7606 5.11031C37.365 6.52009 35.3796 8.53175 34.0014 10.9457C32.6232 13.3596 31.9001 16.092 31.9038 18.8716L31.9203 57.3308L1.69206 91.7982Z",
    fill: "#2356c0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.69bd62ddd1cbe2cbdf0fe0a42d8df8ba.svg";
export { ForwardRef as ReactComponent };